import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { CollectSurveyImagesPage } from '../collect-survey-images/collect-survey-images';
import {SingleSurveyPage} from '../survey/survey';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import swal from 'sweetalert';
import { AlertProvider } from '../../providers/alert/alert';
import { HomePage } from '../home/home';
import * as Survey from 'survey-angular';
import { Http } from '@angular/http';
import { Geolocation } from '@ionic-native/geolocation';
import { LoadingController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TapticEngine } from '@ionic-native/taptic-engine';

@Component({
  selector: 'boiler-survey',
  templateUrl: 'boiler-survey.html',
})
export class BoilerSurveyPage {
  errorMessage = '';
  property_id = 0;
  survey : any = [];
  images = { gas_rate_image:'',trv_installed: [],gas_gauge_working_pressure_image:''};
  lat = '';
  long = '';
  disableButton = false;
  contact = {self_surveyURL:'',customers_telephone:'',delivery_lastname:'',delivery_firstname:'',companyname:'',customer_id:0};
  loader = this.loadingCtrl.create({content: "Uploading image. Please wait..."});

  constructor(
    public navCtrl: NavController,
    public shared: SharedDataProvider,
    public modalCtrl: ModalController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public loading: LoadingProvider,
    public loadingCtrl: LoadingController,
    public iab: InAppBrowser,
    translate: TranslateService,
    public http: Http,
    private geolocation: Geolocation,
    public alert: AlertProvider,
    private camera: Camera,
    private taptic:TapticEngine
  ) {


  }


ionViewWillEnter() {



}

showLoader(){
  this.loader = this.loadingCtrl.create({content: "Uploading image. Please wait..."});
  this.loader.present();
}

hideLoader(){
  this.loader.dismiss();
}

startSurvey(type){
  this.navCtrl.push(CollectSurveyImagesPage, { 'survey': this.survey, 'property_id':  this.property_id , 'image_type':type});
}


gasRateImageold(){
  console.log("Get gas Rate Image");
  const options: CameraOptions = {
  quality: 100,
  destinationType: this.camera.DestinationType.DATA_URL,
  encodingType: this.camera.EncodingType.JPEG,
  mediaType: this.camera.MediaType.PICTURE
}

this.camera.getPicture(options).then((imageData) => {
 // imageData is either a base64 encoded string or a file URI
 // If it's base64 (DATA_URL):

this.uploadGasRateImage('data:image/jpeg;base64,' + imageData);
}, (err) => {
 // Handle error
});
}

uploadGasRateImage(file){
  this.showLoader();

  var data = { file:file,upload_preset:'zrufyns1' };
    this.http.post('https://api.cloudinary.com/v1_1/dzqruihmr/image/upload', data).map(res => res.json()).subscribe(data => {
    this.hideLoader();
    let result: any = data;
    console.log("Response:",result.public_id);
    let thedate = new Date();
    let friendlyDate =   thedate.getDate()+ '-' + (thedate.getMonth()+1) +'-'+thedate.getFullYear();
    let encodedurl = encodeURI('https://res.cloudinary.com/dzqruihmr/image/upload/b_rgb:020202,c_mfit,co_rgb:ffffff,g_south,l_text:Arial_150:'+ friendlyDate + ' Lat:' + this.lat + ' Long:' + this.long + '/'+result.public_id);

    console.log("Image URL:",encodedurl);
    this.images.gas_rate_image = encodedurl;

});
}

submitSurvey(){
  console.log("Submit survey:",this.shared.survey_images);
  var data = {property_id:this.property_id,survey_type:this.survey.pagelink,id:this.survey.survey_id, lat:this.lat ,long:this.long , survey_response:JSON.stringify(this.shared.survey_images)};
  this.http.post(this.config.url + 'postSurvey', data).map(res => res.json()).subscribe(data => {

    console.log("Response:",data);
    this.loading.hide();
    this.taptic.notification({type: "success"});
    swal("Its on its way! Your survey should be with your shortly", {
      icon: "success",
    });

  //  this.navCtrl.push(FinancePage,
  //  {orderID: 0,
  //  fin1:data,
  //  totalPrice:this.orderDetail.totalPrice});
  this.survey.property_id = this.property_id;
  this.navCtrl.push(SingleSurveyPage, { 'data': this.survey});
    if (data.success == 1) {
      console.log("Success");
    }
    else{
      console.log("Something Went Wrong");
    }


  });
}

ngOnInit() {

  var self = this;

  this.survey = this.navParams.get('data');
  this.property_id = this.navParams.get('property_id');
  console.log("Survey Details:",this.survey);
  console.log("Property Id:",this.property_id);


this.geolocation.getCurrentPosition().then(pos => {
  console.log("Got Geo" + pos.coords.latitude);
   this.lat = pos.coords.latitude.toFixed(6);
   this.long = pos.coords.longitude.toFixed(6);


}).catch(err => console.log(err));


console.log("Customer ID:",this.shared.customerData.customers_id)
var data = { ar_id: this.shared.customerData.customers_id,survey_id:this.survey.survey_id };
  this.loading.show();
this.http.post(this.config.url + 'getSurveybyId', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    var survey_JSON = JSON.stringify(data);
    survey_JSON = JSON.parse(survey_JSON);


    });
}
}



// WEBPACK FOOTER //
// ./src/pages/boiler-survey/boiler-survey.ts